module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\r\n\r\n<aside class="jason-map">\r\n\r\n</aside>\r\n';

}
return __p
}